import { render } from "./tHeader.vue?vue&type=template&id=4703ef04&scoped=true"
import script from "./tHeader.vue?vue&type=script&lang=js"
export * from "./tHeader.vue?vue&type=script&lang=js"

import "./tHeader.vue?vue&type=style&index=0&id=4703ef04&lang=less&scoped=true"

import exportComponent from "D:\\codeDevelopment\\文稿通\\wgt_user_web_2.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4703ef04"]])

export default __exports__